import baseRequest, { baseRequestBackendTs } from "./baseRequest"
// 15
export const getCashlessDentalRequests = (params = {}) => {
    const url = '/cashless-dental/ops/all-requests'
    const method = 'GET'
    return baseRequestBackendTs(url, method, params, null)
}

export const getDentalRequests = (requestId) => {
    const url = `/cashless-dental/ops/${requestId}/details`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, null, null);
};

export const getDentalRequestComments = (requestId) => {
    console.log(requestId,'[getDentalRequestComments]')
    const url = `/cashless-dental/ops/get-comments/${requestId}`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, null, null);
};

export const addCommentToRequest = (requestId, comment) => {
    const url = `/cashless-dental/ops/comments/${requestId}`;
    const method = 'POST';
    const data = {comment}
    return baseRequestBackendTs(url, method, null, data);
};

export const getProcedures = (requestId) => {
    // requestId is accepted for API compatibility but ignored by both backends (master list)
    void requestId;
    const url = `/cashless-dental/ops/get-procedures`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, null, null);
};

export const addProcedureRequest = (requestId, procedureId, procedureFee) => {
    const url = `/cashless-dental/mdp/new-ops/add-procedure-request`;
    const method = 'POST';
    const data = {requestId, procedureId, procedureFee}
    return baseRequest(url, method, null, data);
};

export const deductWalletBalance = (requestId, procedureAmount, requestProcedureId, procedureId) => {
    const url = `/cashless-dental/mdp/new-ops/wallet-deduction`;
    const method = 'POST';
    const data = {requestId, procedureAmount, requestProcedureId, procedureId}
    return baseRequest(url, method, null, data);
};

export const callPatient = (requestId) => {
    const url = `/cashless-dental/ops/${requestId}/call/user`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, null);
};

export const markProcedureRemoved = (requestId, requestProcedureId) => {
    const url = `/cashless-dental/ops/mark-procedure-removed`;
    const method = 'POST';
    const data =  {requestId, requestProcedureId};
    return baseRequestBackendTs(url, method, null, data);
}

export const uploadPrescription = (formData) => {
    const url = `/cashless-dental/mdp/new-ops/users/upload-prescription`;
    const method = 'POST';
    const data = formData;
    return baseRequest(url, method, null, data);
};

export const getDentalHistory = (requestId) => {
    const url = `/cashless-dental/ops/request-history/${requestId}`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, null, null);
};

export const cancelDentalModal = (requestId, reason) => {
    const url = `/cashless-dental/mdp/new-ops/cancel-ops-appointment`;
    const method = 'POST';
    const data = {
        reason,
        requestId
    }
    return baseRequest(url, method, null, data);
};

export const refundProcedureAmount = (requestId, procedureRequestsId) => {
    const url = `/cashless-dental/mdp/new-ops/refund-procedure`;
    const method = 'POST';
    const data = {
        requestId, procedureRequestsId
    }
    return baseRequest(url, method, null, data);
};

export const markAppointmentComplete = (requestId) => {
    const url = `/cashless-dental/mdp/new-ops/mark-appointment-complete`;
    const method = 'POST';
    const data = {
        requestId
    }
    return baseRequest(url, method, null, data);
};

export const claimDentalRequest = (requestId) => {
    const url = `/cashless-dental/ops/claim-request/${requestId}`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, null);
};

export const confirmAppointmentAPI = (requestId, requestType) => {
    const url = `/cashless-dental/mdp/new-ops/confirm-appointment`;
    const method = 'POST';
     const data = {
        requestId,
        requestType
    }
    return baseRequest(url, method, null, data);
};

export const getDentalActivityTimeline = (requestId) => {
    const url = `/cashless-dental/ops/get-activity-timeline`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, { requestId }, null);
};

// Paginated: pass { page, limit, centerId?, partnerId?, startDate?, endDate? }.
// Backend wraps as { success, data: { data: [...items], pagination: {...} } };
// baseRequestBackendTs unwraps response.data.data, so this resolves to
// { data: [...items], pagination: {...} }.
export const getDentalSlotBlockAudit = (params = {}) => {
    const url = `/cashless-dental/ops/slot-block-activity`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, params, null);
};

export const getCommsInfo = (requestId) => {
    const url = `/cashless-dental/ops/get-comms-info`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, { requestId }, null);
};

export const retriggerComms = (requestId, eventType) => {
    const url = `/cashless-dental/ops/retrigger-comms`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, { requestId, eventType });
};

// backend ts
export const rescheduleAppointment = (data) => {
    const url = `/cashless-dental/ops/reschedule-appointment`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, data);
};

export const getTimeSlots = (partnerId, doctorId, clinicId) => {
    console.log('getTimeSlots', { partnerId, doctorId, clinicId })
    const url = `/cashless-dental/ops/get-date-slots`;
    const method = 'GET';
    const params = {};
    if (partnerId) {
        params.partnerId = partnerId;
    } else if (doctorId && clinicId) {
        params.doctorId = doctorId;
        params.clinicId = clinicId;
    }
    return baseRequestBackendTs(url, method, params, null);
};

// fetch dental centers and doctors lists
export const fetchDentalCenterAndDoctorLists = (requestId, partnerId, doctorId, clinicId, search) => {
    console.log("fetchDentalCenterAndDoctorLists", { requestId, partnerId, doctorId, clinicId, search })
    const url = `/cashless-dental/ops/list-centers`;
    const method = 'GET';
    const params = { requestId };
    if (partnerId) {
        params.partnerId = partnerId;
    } else if (doctorId && clinicId) {
        params.doctorId = doctorId;
        params.clinicId = clinicId;
    }
    if (search && search.trim().length >= 2) {
        params.search = search.trim();
    }
    return baseRequestBackendTs(url, method, params, null);

}
export const resendCashlessLetter = (requestId) => {
    const url = `/cashless-dental/ops/resend-cashless-letter?requestId=${requestId}`;
    const method = 'GET';
    return baseRequestBackendTs(url, method, null, null);
};

// ops-only: correct the appointment date on an existing dental request
// (overwrites date_key + confirmed_date_key in place; no reschedule comms)
export const updateDentalAppointmentDate = ({ requestId, dateKey, reason }) => {
    const url = `/cashless-dental/ops/update-appointment-date`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, { requestId, dateKey, reason });
};

// change dental center api from ops side
export const changeDentalCenter = (data) => {
    /*
    sample data
    {
    "requestId": 855,
    "reason": "Doctor not available",
    "date": "2026-02-18",
    "slotId": 8,
    "centerId": 48731,
    "partnerId":"2",
    "doctorPracticeId":84284
    }
    */
    const url = `/cashless-dental/ops/change-center`;
    const method = 'POST';
    return baseRequestBackendTs(url, method, null, data);
};